// extracted by mini-css-extract-plugin
export default {"formContainer":"FileExchange_formContainer__sx-fR","title":"FileExchange_title__RPfg4","buttons":"FileExchange_buttons__7cGip"};